import prepareActionTypes from '../../helpers/prepareActionTypes';

export default prepareActionTypes(
  {
    LOAD: {
      INVALID: '',
      REQUESTING: '',
      FAILURE: '',
      SUCCESS: '',
    },
    LOGOUT: '',
    SET_LANG: '',
    PERSONAL_INFO: {
      LOAD: {
        INVALID: '',
        REQUESTING: '',
        FAILURE: '',
        SUCCESS: '',
      },
      SAVE: {
        INVALID: '',
        REQUESTING: '',
        FAILURE: '',
        SUCCESS: '',
      },
    },
    AUTH: {
      CHANGE_PASSWORD: {
        INVALID: '',
        REQUESTING: '',
        FAILURE: '',
        SUCCESS: '',
      },
    },
    RECOVERY_PASSWORD: {
      SEND_CODE: {
        INVALID: '',
        REQUESTING: '',
        FAILURE: '',
        SUCCESS: '',
      },
      CHANGE_PASSWORD: {
        INVALID: '',
        REQUESTING: '',
        FAILURE: '',
        SUCCESS: '',
      },
    },
    TOTAL_BALANCE: {
      INVALID: '',
      REQUESTING: '',
      FAILURE: '',
      SUCCESS: '',
    },
  },
  ['CLIENT']
);
